import { useContext } from 'react';
import { LayoutContext } from '../../context';
import { APIGetMyReferral } from '../../api';
import UserReferralPanel from './UserReferralPanel';

export default function UserReferralCard() {
  const { token } = useContext(LayoutContext);
  if (!token) return null;
  return <UserReferralPanel token={token} loadReferral={APIGetMyReferral} />;
}
